import { SET_CURRENT_LANGUAGE } from "../types";

const reducer = (state, action) => {
  switch(action.type) {
    case SET_CURRENT_LANGUAGE:
      return {
        ...state,
        currentLanguage: action.payload
      }
    default:
      return state
  }
}

export default reducer